import { motion } from "framer-motion";

const PLANT_IMG = "/images/plant.jpg";
const RAIL_IMG = "/images/rail.jpg";

const items = [
  {
    num: "01",
    title: "Sourcing & Aggregation",
    body: "We aggregate chrome-bearing material from across the local mining corridor, consolidating fragmented output into dependable, contract-ready tonnage.",
    testid: "capability-sourcing",
  },
  {
    num: "02",
    title: "Beneficiation",
    body: "Our efficient wash plant upgrades raw feed into 40–42% and higher-grade concentrate. Strong leadership guarantees the seamless growth of our feedstock processing as we scale from +15,000 tons per month.",
    img: PLANT_IMG,
    alt: "Beneficiation processing plant",
    testid: "capability-beneficiation",
  },
  {
    num: "03",
    title: "Mineral Logistics",
    body: "From pit to port — an integrated rail, road and shipping corridor that moves product to clients worldwide, on schedule and on specification.",
    img: RAIL_IMG,
    alt: "Freight rail logistics",
    testid: "capability-logistics",
  },
];

export const Capabilities = () => (
  <section id="capabilities" data-testid="capabilities-section" className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-chrome mb-6">What We Do</p>
    <h2 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[0.95] text-ink max-w-3xl" data-testid="capabilities-heading">
      CAPABILITIES<br />ACROSS THE CHAIN.
    </h2>
    <div className="mt-16 md:mt-20 grid md:grid-cols-3 gap-10 md:gap-8">
      {items.map((c, i) => (
        <motion.article
          key={c.num}
          data-testid={c.testid}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          className={`group ${i === 1 ? "md:mt-16" : i === 2 ? "md:mt-32" : ""}`}
        >
          {c.img && (
            <div className="overflow-hidden mb-8">
              <img
                src={c.img}
                alt={c.alt}
                className="spotlight w-full aspect-[4/3] object-cover group-hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
          )}
          <span className="font-display font-semibold text-3xl text-outline-blue group-hover:text-chrome transition-colors duration-500">{c.num}</span>
          <h3 className="font-display font-semibold text-2xl md:text-3xl tracking-tight text-ink mt-4 leading-snug">{c.title}</h3>
          <p className="text-base leading-relaxed text-slate-600 mt-4">{c.body}</p>
        </motion.article>
      ))}
    </div>
  </section>
);
